"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1533],{

/***/ 61533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M14.4 5H21c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1h-8v1h2.5c.6 0 1 .4 1 1s-.4 1-1 1h-7c-.6 0-1-.4-1-1s.4-1 1-1H11v-1H3c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h6.6L8.3 3.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L12 4.6l2.3-2.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L14.4 5zM4 7v10h16V7H4zm4.3 5.3l2-2c.4-.4 1-.4 1.4 0l1.3 1.3 1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-2 2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3L11 12.4l-1.3 1.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4z"
}), "Television"));


/***/ })

}]);